import { useLogin } from '@/providers/login/LoginProvider';
import { useIsActivePrimeUser } from '@/providers/PrimeUserProvider';

export function useIsPrimeUser() {
  const { isPrime: isLoggedPrime } = useLogin();
  const { isActive: isRecognizedPrime } = useIsActivePrimeUser();
  return isLoggedPrime || isRecognizedPrime;
}
